(() => {
  // =========================
  // Config & Debug Controls
  // =========================
  const CONFIG = {
    // https://default95ea887b8b864325bba354a90e4281.10.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/511da3c6f3124c35b1f5a2ec1790758a/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=ZExoG7OJ4CickSb9qLut8f7xE2dbIq3W8sXFViBsimg
    // endpoint: 'https://prod-109.westeurope.logic.azure.com/workflows/511da3c6f3124c35b1f5a2ec1790758a/triggers/manual/paths/invoke',
    endpoint:
      "https://default95ea887b8b864325bba354a90e4281.10.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/56532b78776c4040b0b2ef8e05b13c7c/triggers/manual/paths/invoke",
    params: {
      // 'api-version': '2016-06-01',
      "api-version": "1",
      sp: "/triggers/manual/run",
      sv: "1.0",
      // sig: 'OOvCQ5SFSidJhEOJWagiPKs-_KcjPQQjpYBzAHDQNds' // visible client-side; consider proxying in prod
      sig: "M5O3Hyy9F5v5vqSp6dhkFbn2G4PbsymFk5s2v8y9Y1M",
    },
    request: {
      method: "POST",
      mode: "cors",
      cache: "no-store",
      headers: { "Content-Type": "application/json" },
    },
    retries: { attempts: 2, baseDelayMs: 300 },

    // Your custom HTML block
    containerSelector: "#next-po-message",

    // Used only to detect the SKU to query
    preferredHookSelector: "#po-hook",

    // Logging
    defaultLogLevel: "info",
  };

  // Enable debug logs via ?po-debug=1 OR localStorage.setItem('po-debug','1')
  const urlParams = new URLSearchParams(location.search);
  const debugEnabled =
    urlParams.get("po-debug") === "1" ||
    localStorage.getItem("po-debug") === "1";

  // ==================================
  // Lightweight Logger (namespaced)
  // ==================================
  const LOG_NS = "[PO]";
  const LEVELS = { error: 0, warn: 1, info: 2, debug: 3 };
  let currentLevel = debugEnabled ? "debug" : CONFIG.defaultLogLevel;
  const Log = {
    setLevel(l) {
      if (LEVELS[l] !== undefined) currentLevel = l;
    },
    on(l) {
      return LEVELS[currentLevel] >= LEVELS[l];
    },
    error(...a) {
      console.error(LOG_NS, ...a);
    },
    warn(...a) {
      if (this.on("warn")) console.warn(LOG_NS, ...a);
    },
    info(...a) {
      if (this.on("info")) console.info(LOG_NS, ...a);
    },
    debug(...a) {
      if (this.on("debug")) console.debug(LOG_NS, ...a);
    },
    group(label) {
      if (this.on("info")) console.groupCollapsed(`${LOG_NS} ${label}`);
    },
    groupEnd() {
      if (this.on("info")) console.groupEnd();
    },
    time(id) {
      if (this.on("info")) console.time(`${LOG_NS} ${id}`);
    },
    timeEnd(id) {
      if (this.on("info")) console.timeEnd(`${LOG_NS} ${id}`);
    },
  };
  window.__poSetLogLevel = (lvl) => Log.setLevel(lvl);

  // =========================
  // Utilities
  // =========================
  const maskSigInUrl = (str) => str.replace(/([?&]sig=)[^&]+/i, "$1***");

  function ensureStyles() {
    if (document.getElementById("po-inline-style")) return;
    const css = `
      #next-po-message .po-wrap { margin: 0; }
      #next-po-message .po-line-1 { margin: 0; }
      #next-po-message .po-line-1 strong { font-weight: 700; }
      #next-po-message .po-line-1 .po-date { font-weight: 400; }
      #next-po-message .po-line-2 { margin: 2px 0 0 0; font-style: italic; opacity: 0.95; }
    `;
    const style = document.createElement("style");
    style.id = "po-inline-style";
    style.textContent = css;
    document.head.appendChild(style);
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function markup(prettyDate) {
    return `
      <div class="po-wrap" role="status" aria-live="polite">
        <p class="po-line-1">
          <strong>Next Purchase Order Expected:</strong>
          <span class="po-date">${escapeHtml(prettyDate)}</span>
        </p>
        <p class="po-line-2">
          <em>Please allow additional time for booking in and processing.</em>
        </p>
      </div>
    `;
  }

  const getContainer = () => {
    const el = document.querySelector(CONFIG.containerSelector);
    if (!el) Log.warn("Target container not found:", CONFIG.containerSelector);
    return el;
  };

  const showContainer = (html) => {
    const el = getContainer();
    if (!el) return;
    ensureStyles();
    el.innerHTML = html;
    el.style.display = ""; // unhide; theme controls final look
    Log.info("Message rendered in container:", el);
  };

  const hideContainer = (reason = "") => {
    const el = getContainer();
    if (!el) return;
    el.innerHTML = "";
    el.style.display = "none";
    Log.info("Container hidden.", reason ? `Reason: ${reason}` : "");
  };

  function findSkuCandidates() {
    const results = [];
    const hook = document.querySelector(CONFIG.preferredHookSelector);
    if (hook?.dataset?.sku)
      results.push({
        source: "hook",
        value: hook.dataset.sku.trim(),
        el: hook,
      });
    const itemprop = document.querySelector('[itemprop="sku"]');
    if (itemprop)
      results.push({
        source: "itemprop",
        value: (
          itemprop.getAttribute("content") ||
          itemprop.textContent ||
          ""
        ).trim(),
        el: itemprop,
      });
    const legacy = document.querySelector(
      "p.product-single__sku, .product__sku, .product-sku, [data-product-sku]"
    );
    if (legacy)
      results.push({
        source: "legacy",
        value: (
          legacy.textContent ||
          legacy.getAttribute("data-product-sku") ||
          ""
        ).trim(),
        el: legacy,
      });
    return results.filter((x) => x.value);
  }

  function getSkuWithLogging() {
    Log.group("SKU detection");
    const candidates = findSkuCandidates();
    if (candidates.length === 0) {
      Log.warn("No SKU candidates found in DOM.");
      Log.groupEnd();
      return { sku: "", origin: null, el: null };
    }
    const preferred =
      candidates.find((c) => c.source === "hook") || candidates[0];
    candidates.forEach((c) =>
      Log.debug(`Candidate [${c.source}] →`, c.value, c.el)
    );
    Log.info(`Chosen SKU [${preferred.source}]:`, preferred.value);
    Log.groupEnd();
    return { sku: preferred.value, origin: preferred.source, el: preferred.el };
  }

  const buildApiUrl = (sku) => {
    // The API expects the SKU in the POST body; keep auth/query params but do not place id in the query string
    const url = new URL(CONFIG.endpoint);
    url.search = new URLSearchParams({ ...CONFIG.params }).toString();
    console.info("URL-TM:", url.toString());
    return url.toString();
  };

  const extractIsoDate = (text) => {
    const trimmed = (text || "").trim().replace(/^"|"$/g, "");
    let m = trimmed.match(/^(\d{4}-\d{2}-\d{2})$/);
    if (m) return m[1];
    m = trimmed.match(/^(\d{4}-\d{2}-\d{2})/);
    return m ? m[1] : "";
  };

  const isSuppressedDate = (iso) => !iso || iso === "0001-01-01";

  const isIsoDate = (str) => /^\d{4}-\d{2}-\d{2}$/.test(str);

  const prettyDateFromIso = (isoDate) => {
    const [y, m, d] = isoDate.split("-").map(Number);
    const dt = new Date(Date.UTC(y, m - 1, d));
    return dt.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      timeZone: "UTC",
    });
  };

  async function fetchWithRetry(url, options, attempts, baseDelayMs) {
    let lastError;
    for (let i = 0; i <= attempts; i++) {
      const attemptNo = i + 1;
      Log.group(`Network attempt ${attemptNo}/${attempts + 1}`);
      Log.info("Request URL:", maskSigInUrl(url));
      Log.debug("Fetch options:", options);
      const tId = `fetch ${attemptNo}`;
      Log.time(tId);
      try {
        const res = await fetch(url, options);
        Log.timeEnd(tId);
        Log.info("Response status:", res.status);
        Log.debug("Response headers:", [...res.headers.entries()]);
        const preview = await res
          .clone()
          .text()
          .then((t) => (t.length > 200 ? t.slice(0, 200) + "…" : t))
          .catch(() => "(preview read failed)");
        Log.debug("Body preview:", preview);
        if (!res.ok) {
          if (res.status >= 400 && res.status < 500 && res.status !== 429) {
            Log.warn("Non-retryable HTTP status:", res.status);
            return res;
          }
          lastError = new Error(`HTTP ${res.status}`);
          throw lastError;
        }
        Log.groupEnd();
        return res;
      } catch (err) {
        Log.warn("Fetch error:", err?.message || err);
        Log.timeEnd(tId);
        Log.groupEnd();
        lastError = err;
        if (i < attempts) {
          const delay =
            baseDelayMs * Math.pow(2, i) + Math.floor(Math.random() * 100);
          Log.info(`Retrying in ~${delay}ms…`);
          await new Promise((r) => setTimeout(r, delay));
          continue;
        }
        break;
      }
    }
    throw lastError;
  }

  // =========================
  // Main flow
  // =========================
  let lastRenderedSku = "";
  let inFlight = false;

  async function callApiAndRender() {
    if (inFlight) {
      Log.info("Previous request still in flight; skipping.");
      return;
    }

    Log.group("Run");
    hideContainer("init (avoid stale content while fetching)");

    const { sku, origin } = getSkuWithLogging();
    if (!sku) {
      hideContainer("No SKU found");
      Log.groupEnd();
      return;
    }

    if (sku === lastRenderedSku) {
      Log.info("SKU unchanged; skipping re-render.", { sku });
      Log.groupEnd();
      return;
    }

    const url = buildApiUrl(sku);
    inFlight = true;
    Log.info("Built URL:", maskSigInUrl(url));
    Log.debug("Params:", { ...CONFIG.params, id: sku, sig: "***" });

    try {
      // Send SKU in JSON body for POST
      const options = {
        ...CONFIG.request,
        body: JSON.stringify({ id: sku }),
      };
      const res = await fetchWithRetry(
        url,
        options,
        CONFIG.retries.attempts,
        CONFIG.retries.baseDelayMs
      );
      const rawText = await res.text();

      const iso = extractIsoDate(rawText);
      Log.info("Raw API text:", (rawText || "").trim());
      Log.info("Extracted ISO date:", iso || "(none)");

      if (isSuppressedDate(iso)) {
        hideContainer(
          iso ? `Suppressed sentinel date (${iso})` : "Empty/null date"
        );
        lastRenderedSku = ""; // reset
        return;
      }
      if (!isIsoDate(iso)) {
        hideContainer("Unexpected date format (expecting YYYY-MM-DD)");
        Log.warn("Unexpected response format:", iso);
        lastRenderedSku = ""; // reset
        return;
      }

      const pretty = prettyDateFromIso(iso);
      showContainer(markup(pretty));
      lastRenderedSku = sku;
      Log.info("Rendered for SKU:", sku, `(${origin})`);
    } catch (err) {
      Log.error("API/render error:", err?.message || err);
      hideContainer("API error");
    } finally {
      inFlight = false;
      Log.groupEnd();
    }
  }

  // =========================
  // Event Wiring
  // =========================
  function onVariantChange(e) {
    Log.group("variant:change");
    try {
      const variant = e?.detail?.variant;
      if (variant)
        Log.info(
          "Variant id:",
          variant.id,
          "SKU:",
          variant.sku,
          "Title:",
          variant.title
        );
      callApiAndRender();
    } catch (err) {
      Log.error("Error handling variant:change:", err);
    } finally {
      Log.groupEnd();
    }
  }

  function onSectionLoad(e) {
    Log.group("shopify:section:load");
    Log.info("Section target:", e?.target);
    callApiAndRender();
    Log.groupEnd();
  }

  function onReady() {
    Log.info("DOMContentLoaded fired.");
    callApiAndRender();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }
  document.addEventListener("variant:change", onVariantChange);
  document.addEventListener("shopify:section:load", onSectionLoad);

  // Manual console trigger:
  window.__poRefresh = callApiAndRender;
})();
